import AmioHttpService from './amio-http.service'

class IntentService extends AmioHttpService {

  get(intentId) {
    return this.requestGet(`/intents/${intentId}`)
      .then(response => adapt(response.data))
      .catch(err => {
        throw this.handleError(err)
      })
  }

  update(intentId, patch) {
    return this.requestPatch(`/intents/${intentId}`, patch)
      .then(response => adapt(response.data))
      .catch(err => {
        throw this.handleError(err)
      })
  }
}

function adapt(intent) {
  return {
    id: intent.id,
    platformId: intent.platform_id,
    description: intent.description,
    example: intent.example,
    requestOutcome: intent.request_outcome
  }
}

export default new IntentService()
